import Vue from 'vue'
import { ToastPlugin, ModalPlugin, CollapsePlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueSweetalert2 from 'vue-sweetalert2'
import { ToggleButton } from 'vue-js-toggle-button'
import VueVideoPlayer from 'vue-video-player'
// import * as VueGoogleMaps from 'vue2-google-maps'
import 'videojs-contrib-hls/dist/videojs-contrib-hls'
import router from './router'
import store from './store'
import App from './App.vue'
// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import 'vue-select/dist/vue-select.css'
import 'vue-good-table/dist/vue-good-table.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flash'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'flatpickr/dist/flatpickr.css'
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)
Vue.use(VueVideoPlayer)
Vue.use(VueCompositionAPI)
Vue.use(VueSweetalert2)
Vue.component('ToggleButton', ToggleButton)
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@core/scss/vue/libs/vue-flatpicker.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
